import React, { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    Stack,
    Text,
    CloseButton,
    Box,
    Flex,
    VStack, 
    useToast
} from "@chakra-ui/react";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {useServerIP} from "../../../redux/ServerIPContext";
import {clearChatHistoryMultidoc} from "../../../utils/multi-doc-helpers";
import {clearMessagesInDocumentGeneration} from "../../../redux/reducers";

const ClearChatModal = ({ isOpen, onClose, userID, multidocID, isLoggedIn }) => {
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const { serverIPs } = useServerIP();

    const clearChatAction = async () => {
        setIsLoading(true);
        try {
            const response = await clearChatHistoryMultidoc(userID, multidocID, isLoggedIn, serverIPs.SERVER_IP_MULTIDOC);
            setIsLoading(false);
            
            if (response === "success") {
                // Clear the messages in Redux
                dispatch(clearMessagesInDocumentGeneration({ documentID: multidocID }));
                
                toast({
                    title: t('Chat history cleared. You can start fresh now!'),
                    status: "success",
                    duration: 9000,
                    isClosable: true,
                });
                onClose();
            } else {
                toast({
                    title: t('Failed to clear chat history. Please try again.'),
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                });
            }
        } catch (error) {
            setIsLoading(false);
            toast({
                title: t('Oops, something went wrong. Please try again.'),
                status: "error",
                duration: 9000,
                isClosable: true,
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
            <ModalOverlay />
            <ModalContent borderRadius="1rem" p="0.75rem" h="18rem" w="26rem" overflowY="auto" position="relative">
                <Box
                    position="absolute"
                    top="10px"
                    right="10px"
                    zIndex={999}
                >
                    <CloseButton
                        size="md"
                        onClick={onClose}
                        bg="transparent"
                        borderRadius="50%"
                        _hover={{
                            bg: "gray.200",
                            borderRadius: "50%",
                        }}
                    />
                </Box>
                <Flex alignItems="center" justifyContent="space-between" p={4}>
                    <VStack align="center" width={'100%'} spacing={6}>
                        <Text fontSize="xl" fontWeight="bold">{t('Clear Chat History?')}</Text>
                        <Text fontSize="sm" fontWeight="light" textAlign={"center"}>
                            {t('Start fresh by clearing all chat messages in this conversation only. Your uploaded sources will remain.')}
                        </Text>
                    </VStack>
                </Flex>
                <ModalBody>
                    <Stack spacing={4}>
                        <Stack spacing={10} pt={4}>
                            <Button
                                loadingText="Clearing..."
                                size="lg"
                                isLoading={isLoading}
                                bg={'red.400'}
                                color={'white'}
                                onClick={clearChatAction}
                                _hover={{
                                    bg: 'red.500',
                                }}>
                                {t('Clear Chat History')}
                            </Button>
                        </Stack>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ClearChatModal;

